module.exports = __webpack_public_path__ + "catalog/items/firesafety/Fire-Extinguisher-Water-Mist/Fire-Extinguisher-Water-Mist.svg";